// extracted by mini-css-extract-plugin
module.exports = {"options":"OptionItem_options__VX4Y2","value":"OptionItem_value__hZv_P","icon":"OptionItem_icon__j30Zb"};